import { Spin, Button, Card, Form, Select, Space, Table, Input, ConfigProvider, Popover, Typography, Pagination, message, Checkbox, Popconfirm,Row,Col } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import App from '../LayoutMobile';
import { DeleteOutlined, EditOutlined, QuestionCircleOutlined, SwitcherOutlined, EyeOutlined } from "@ant-design/icons";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Config } from '../Common/Config';
import './Gpproductadmin.css';

const getInitials = (name = '') => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return '?';
};


const { Option } = Select;
const { Title } = Typography;


const Gpproductadmin = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  let showCategoryTemp = localStorage.getItem('showCategory'), showCategory = null
  if (showCategoryTemp) {
    showCategory = JSON.parse(showCategoryTemp)
  }
  const [userDataSet, setuserDataSet] = useState({})
  const [AllClinicianData, setAllClinicianData] = useState([])
  const [loader, setloader] = useState(false)
  const [messageApi, contextHolder] = message.useMessage();
  const [CurrentPage, setCurrentPage] = useState(1)
  const [isUserCreateEnable, setisUserCreateEnable] = useState(false)
  const [showAddButton, setshowAddButton] = useState(true)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [formMode, setFormMode] = useState('edit')
  const isViewMode = formMode === 'view'


  // useEffect(() => {
  //   getAllProductData(CurrentPage)
  // }, [CurrentPage])
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      getAllProductData(CurrentPage);
      hasFetched.current = true;
    }
  }, [CurrentPage]);

  const getAllProductData = async (CurrentPage, searchValue = null) => {
    if (!CurrentPage) {
      return
    }
    setloader(true)
    try {
      let url = `${Config.url}gp-product/page/${CurrentPage}`
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      setloader(false)
      // console.log('gp-product ::::', response?.data?.data)
      setAllClinicianData(response?.data?.data)
      hasFetched.current = false;
    } catch (error) {
      console.log('error in gp-product ::::', error)
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || "Something went wrong",
      });
      setloader(false)
    }
    setloader(false)
  }


  const onFinish = async (values, update = false) => {
    setIsSubmitting(true)
    if (!update) {
      try {
        let payload = {
          ...values,
          "product_category_id": 1,
          "status": 1
        }
        const response = await axios.post(`${Config.url}gp-product`, payload, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        messageApi.success({
          type: 'succes',
          content: 'Product Created successfully',
        });
        setuserDataSet({})
        form.setFieldsValue({
          "name": ''
        });
        setloader(false)
        setIsSubmitting(false)
        setisUserCreateEnable(false)
        setshowAddButton(true)
        setFormMode('edit')
        getAllProductData(CurrentPage)
      } catch (error) {
        messageApi.error({
          type: 'error',
          content: error.response?.data?.message || error.message || 'Something Went wrong',
        });
        console.log('create user:', error.response?.data || error.message);
        setloader(false);
        setIsSubmitting(false);
        // throw error;
      }

    } else {
      if (!Object.keys(userDataSet).length && !userDataSet.gp_product_id) {
        return
      }
      let url = `${Config.url}gp-product/${userDataSet.gp_product_id}`
      try {
        const response = await axios.put(url, {
          ...values,
          "product_category_id": 1,
          "status": 1
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        setuserDataSet({})
        form.setFieldsValue({
          ...values,
          "product_category_id": "",
          "status": "",
          'name':''
        });
        messageApi.success({
          type: 'succes',
          content: 'Product Updated successfully',
        });
        setloader(false)
        setIsSubmitting(false)
        setisUserCreateEnable(false)
        setshowAddButton(true)
        setFormMode('edit')
        getAllProductData(CurrentPage)
      } catch (error) {
        messageApi.error({
          type: 'error',
          content: error.response?.data?.message || error.message || 'Something Went wrong',
        });
        console.log('update user:', error.response?.data?.message || error.message);
        setloader(false);
        setIsSubmitting(false);
        // throw error;
      }
      // console.log("Form values: false", values);
    }
    setloader(false)
    setIsSubmitting(false)
  };
  const handleRowClick = (record) => {
    setFormMode('view');
    setloader(true);
    setshowAddButton(false);
    setisUserCreateEnable(true);
    setuserDataSet(record);
    form.setFieldsValue(record);
    setloader(false);
    document.querySelector(".gpProductCreate-form")?.scrollIntoView({ behavior: "smooth" });
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: <div className="table-title" style={{textAlign: "left !important"}}>Name</div>,
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => (
        <div style={{ textAlign: "left !important" }}>{record.name}</div>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_, record) => (
        <div>
          {record?.status == 1 ? 'Active' : 'Inactive'}
        </div>
      ),
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
          <Popover placement="left" trigger="click" content={() => content(record)}>
            <button
              onClick={(e) => e.stopPropagation()}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                fontWeight: 700, fontSize: 18, letterSpacing: 2,
                color: '#008385', padding: '0 6px', lineHeight: 1,
              }}
            >···</button>
          </Popover>
        </div>
      ),
    },
  ];

  const content = (record) => (
    <div className="rule-action-popover" style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
      <div
        className="rule-action-item"
        style={{ color: '#008385' }}
        onClick={(e) => {
          e.stopPropagation()
          setFormMode('view');
          setloader(true)
          setshowAddButton(false)
          setisUserCreateEnable(true)
          setuserDataSet(record)
          form.setFieldsValue(record);
          setloader(false)
          document.querySelector(".gpProductCreate-form")?.scrollIntoView({ behavior: "smooth" });
        }}
      >
        <EyeOutlined style={{ fontSize: 15 }} /> View
      </div>
      <div
        className="rule-action-item"
        style={{ color: '#008385' }}
        onClick={(e) => {
          e.stopPropagation()
          setFormMode('edit')
          setloader(true)
          setshowAddButton(false)
          setisUserCreateEnable(true)
          setuserDataSet(record)
          form.setFieldsValue(record);
          setloader(false)
          document.querySelector(".gpProductCreate-form")?.scrollIntoView({ behavior: "smooth" });
        }}
      >
        <EditOutlined style={{ fontSize: 15 }} /> Edit
      </div>
      <div className="rule-action-divider" />
      <Popconfirm
        title="Update"
        description="Are you sure you want to update status?"
        onCancel={() => updateStatus(record)}
        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
        okButtonProps={{ className: 'confirmation-popup-ok-button' }}
        cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
        okText="No"
        cancelText="Yes"
      >
        <div className="rule-action-item" style={{ color: '#008385' }} onClick={(e) => e.stopPropagation()}>
          <SwitcherOutlined style={{ fontSize: 15 }} /> {record && record.status == 1 ? 'Make Inactive' : 'Make Active'}
        </div>
      </Popconfirm>
      <div className="rule-action-divider" />
      <Popconfirm
        title="Delete"
        description="Are you sure you want to delete?"
        onCancel={() => deleteUser(record)}
        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
        okButtonProps={{ className: 'confirmation-popup-ok-button' }}
        cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
        okText="No"
        cancelText="Yes"
      >
        <div className="rule-action-item rule-action-item--delete" onClick={(e) => e.stopPropagation()}>
          <DeleteOutlined style={{ fontSize: 15 }} /> Delete
        </div>
      </Popconfirm>
    </div>
  );
  const updateStatus = async (record) => {
    // console.log(':::::record', record)
    if (!record?.gp_product_id) {
      return
    }
    setloader(true)
    let url = `${Config.url}gp-product/${record.gp_product_id}`
    try {
      const response = await axios.put(url, {
        'name': record?.name,
        "product_category_id": 1,
        "status": record && record.status == 1 ? 0 : 1
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      // console.log(' Successful:', response);

      messageApi.success({
        type: 'succes',
        content: 'Product status updated successfully',
      });
      setloader(false)
      getAllProductData(CurrentPage)
    } catch (error) {
      messageApi.error({
        type: 'error',
        content: 'Something Went wrong',
      });
      console.log('update user:', error.response?.data || error.message);
      // throw error;
    }

  }
  const deleteUser = async (record) => {
    // console.log('deleteUser record:', record);
    let url = `${Config.url}gp-product/${record.gp_product_id}`
    try {
      const response = await axios.delete(url, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      // console.log(' Successful:', response);
      messageApi.success({
        type: 'succes',
        content: 'Product deleted successfully',
      });
      getAllProductData(CurrentPage)
    } catch (error) {
      console.log('deleteUser:', error.response?.data || error.message);
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || 'Something went wrong',
      });
      throw error;
    }
  }
  const itemRender = (_, type, originalElement) => {
    if (type === 'prev') {
      return <a style={{ color: '#4A4A4A' }}>Previous</a>;
    }
    if (type === 'next') {
      return <a style={{ color: '#4A4A4A' }}>Next</a>;
    }
    return originalElement;
  };
  const createUser = () => {
    setisUserCreateEnable(true)
    setFormMode('edit')
  }

  const Products = [
    {
      label: 'All GP consultations',
      value: 'all_gp_consultations',

    },
    {
      label: 'All health screens',
      value: 'all_health_screens',
      style: { marginLeft: 172 }
    }
  ];

  return (
    <App>
      {contextHolder}
      <div style={{ display: 'grid', justifyContent: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 15 }}>
          <div style={{ display: "flex", justifyContent: 'space-around', alignItems: "center", marginBottom: "10px", marginInline: 20 }}>
            <Title level={5} style={{ margin: 0, color: "#008385", fontSize: 20 }}>
              All products in the category <span style={{ color: "black", fontWeight: '400' }}>({AllClinicianData?.total ? AllClinicianData?.total : '00'})</span>
            </Title>
            {/* <div></div> */}
          </div>
          <Select
            placeholder="GP Appointment"
            style={{ width: "215px", height: 40 }}
            allowClear
            defaultValue={'gp_appointment'}
            onSelect={(value) => {
              // console.log(':::::::::::::::', value)
              if (value && value == 'health_screens') {
                navigate('/product-category')
              }
            }}
          >
            <Option value="gp_appointment">{showCategory && showCategory.category1 && showCategory.category1?.name ? showCategory.category1.name : 'GP Appointments'}</Option>
            <Option value="health_screens">{showCategory && showCategory.category2 && showCategory.category2?.name? showCategory.category2.name : 'Health screens'}</Option>
          </Select>
          {/* <Button type="default" className='add-generic-btn' style={{ borderColor: '#008385', width: "215px", height: 40 }} onClick={() => navigate('/product-categories')}>Add a category</Button> */}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Card
            style={{ width: 937, margin: 0, padding: 0, borderRadius: 40, boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)" }}
          >
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    headerBg: "#008385",
                    headerColor: "#ffffff",
                  },
                  Spin: {
                    colorPrimary: "#008385", // Change this to your desired color
                  },
                },
              }}
            >
              {AllClinicianData && <Table
                loading={loader}
                columns={columns}
                dataSource={AllClinicianData?.data}
                pagination={false}
                rowClassName="selectRow"
                onRow={(record) => ({
                  onClick: () => handleRowClick(record),
                  style: { cursor: 'pointer' }
                })}
                scroll={{
                  x: 'auto',
                }}
                // style={{ height: '400px' }}
              />}
              {AllClinicianData && AllClinicianData?.total ? <Pagination
                align="center"
                defaultCurrent={1}
                defaultPageSize={10}
                total={AllClinicianData?.total ? AllClinicianData?.total : undefined}
                style={{ marginTop: 10 }}
                onChange={(val, filter) => {
                  setCurrentPage(val)
                }}
                itemRender={itemRender}
              /> : ''}
            </ConfigProvider>
          </Card>
        </div>
      </div>
      <div className='button-add-left' style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20 }}>
        {showAddButton && <Button type="default" onClick={createUser}>Add a Product</Button>}
        </div>
      <div className='gpProductCreate-form' style={{ display: "flex", alignItems: "flex-start", gap: "10px", marginTop: 20, justifyContent: "center" }}>
        {loader == false && isUserCreateEnable && (
          <Card
            className={isViewMode ? 'view-mode-card' : ''}
            title={
              isViewMode ? (
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{
                    width: 36, height: 36, borderRadius: '50%',
                    background: 'linear-gradient(135deg, #008385, #00a3a5)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#fff', fontWeight: 700, fontSize: 14, flexShrink: 0,
                    boxShadow: '0 2px 6px rgba(0,131,133,0.30)',
                  }}>
                    {getInitials(userDataSet?.name)}
                  </div>
                  <span style={{ fontWeight: 700, fontSize: 16, color: '#007a7c' }}>
                    {userDataSet?.name}
                  </span>
                </div>
              ) : (
                <span style={{ textAlign: "left", display: "block" }}>Product details</span>
              )
            }
            style={{ width: 460, margin: "0", marginTop: 20 }}
          >
            {isViewMode ? (
              <div style={{ padding: '0 4px' }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#008385', letterSpacing: 1,
                  textTransform: 'uppercase', marginBottom: 8, paddingBottom: 4,
                  borderBottom: '1px solid #c5e8e8' }}>
                  Product Info
                </div>
                <div className="view-detail-row">
                  <label>Name</label>
                  <span className="view-field-value">{userDataSet?.name || '-'}</span>
                </div>
                <div className="view-detail-row">
                  <label>Status</label>
                  <span className="view-field-value">
                    {userDataSet?.status == 1 ? 'Active' : 'Inactive'}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: 12, marginTop: 20, paddingBottom: 4 }}>
                  <Button
                    onClick={() => { setisUserCreateEnable(false); setshowAddButton(true); setFormMode('edit'); }}
                    style={{ borderColor: '#008385', color: '#008385', minWidth: 100 }}
                  >Cancel</Button>
                  <Button
                    className="edit-btn-green"
                    icon={<EditOutlined />}
                    onClick={() => setFormMode('edit')}
                    style={{ minWidth: 100 }}
                  >Edit</Button>
                </div>
              </div>
            ) : (
              userDataSet && <Form form={form} autoComplete="off" layout="vertical" initialValues={userDataSet ? userDataSet : null} onFinish={(values) => onFinish(values, userDataSet && Object.keys(userDataSet).length ? true : false)}>
                <Row>
                  <Col span={3}>
                    <Space.Compact style={{ width: "100%" }}>
                      <label style={{ marginTop: 5,}}>Name: {' '}</label>
                    </Space.Compact>
                  </Col>
                  <Col span={21}>
                    <Form.Item
                      name="name"
                      rules={[{ required: true, message: "Product name is required" }]}
                      style={{ width: "100%", marginBottom: 0 }}
                    >
                      <Input placeholder="Product Name" style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                </Row>
                <>
                  <Button className="add-generic-btn" style={{ backgroundColor: '#008385', color: '#fff', marginRight: 10, marginTop: '10px' }} onClick={() => {
                    form.setFieldsValue({ "name": '' });
                    setisUserCreateEnable(false);
                    setshowAddButton(true);
                    setFormMode('edit');
                  }}>
                    Cancel
                  </Button>
                  <Button
                    style={{
                      backgroundColor: isSubmitting ? '#80bebe' : '#008385',
                      borderColor: isSubmitting ? '#80bebe' : '#008385',
                      color: '#fff',
                      cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    }}
                    loading={isSubmitting}
                    disabled={isSubmitting}
                    htmlType="submit"
                  >
                    {isSubmitting ? 'Saving...' : 'Save'}
                  </Button>
                </>
              </Form>
            )}
          </Card>
        )}
      </div>

    </App>
  )
}

export default Gpproductadmin

//  if (error.response?.data && error.response?.data?.error && error.response?.data?.error == 'Unauthenticated.') {
//         console.log('Unauthenticated :::', error.response?.data?.error)
//         localStorage.clear();
//          navigate('/')
//       }